import React, { createContext, useContext } from 'react';

export const LayoutContext = createContext({
    darkNavigationTheme: false,
    setDarkNavigationTheme: (dark: boolean) => {
        if (dark) {
            return true;
        } else {
            return false;
        }
    },
    sidebarExpanded: false,
    currentSubmenu: ``,
    quizResults: null,
    setQuizResults: (quizResults: {
        [key: string]: string | number | boolean;
    }) => {
        //
    },
    setCurrentSubmenu: (submenu: string) => {
        //
    },
    setSidebarExpanded: (expanded: boolean) => {
        //
    },
    searchOpen: true,
    setSearchOpen: (expanded: boolean) => {
        //
    },
    urlParams: ``,
    setUrlParams: (params: string) => {
        //
    },
    nodeLookup: [],
    setNodeLookup: (nodeMap: { nodeId: number; path: string }[]) => {
        //
    },
    inlineAnchor: ``,
    setInlineAnchor: (val: string) => void null,
    inputProspect: null,
    setInputProspect: (inputProspect: {
        [key: string]: string | number | boolean;
    }) => null,
    campaignTermsFilter: [],
    setCampaignTermsFilter: (filters: string[]) => [],
    customCTA: { title: ``, uri: `` },
    setCustomCTA: (cta: { title: string; uri: string }) => {
        //
    },
    contactFormID: ``,
    setContactFormID: (val: string) => ``,
    headerRef: null,
    setHeaderRef: (el: HTMLHeadElement) => void null,
    navigationSelect: null,
    setNavigationSelect: function (val: string | null) {
        //
    },
});

export const LayoutContextProvider = ({ value, children }) => {
    return (
        <LayoutContext.Provider
            value={{
                ...value,
            }}
        >
            {children}
        </LayoutContext.Provider>
    );
};

export const useLayoutContext = () => useContext(LayoutContext);
